<template>
  <div class="home-goods-new">
    <!-- 标题加商品横向滚动样式（店主身份 && navigationType === 0） -->
    <div v-if="item.navigationType === 0 && isStore" class="title-with-list">
      <div class="title-header">
        <span class="header-title">{{ item.title }}</span>
        <div v-if="item.forwardType !== 4" class="see-more-btn" @click="onMoreClick">
          <span class="see-more-text">查看更多</span>
          <van-icon name="arrow" class="arrow-icon" />
        </div>
      </div>
      <div class="subject-goods-scroll-wrapper" v-if="item.spus && item.spus.length > 0">
        <div class="subject-goods-list">
          <div
            v-for="goods in item.spus"
            :key="goods.id"
            class="subject-goods-cell"
            @click="onGoodsClick(goods)"
          >
            <div class="cell-img-box">
              <img :src="goods.thumbnailImg || goods.spuImg" class="cell-image" />
            </div>
            <div class="cell-info">
              <div class="cell-name">{{ goods.name }}</div>
              <div class="cell-price-group">
                <div class="cell-price-row">
                  <span class="price-integer">{{ goods.finalPrice | currency(false) }}</span>
                </div>
                <div v-if="goods.singlePrice" class="single-price">
                  {{ goods.singlePrice | currency(false) }}{{ goods.uom ? '/' + goods.uom : '' }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 图片展示样式（大图广告，下面可能会叠加横向滚动商品） -->
    <div v-else class="image-with-list">
      <img
        class="main-image"
        :src="item.appImg || item.wechatImg || item.imageUrl"
        :style="{ minHeight: minHeight }"
        @click="onImageClick"
      />
      <div
        v-if="item.navigationType === 2 && item.spus && item.spus.length > 0"
        class="overlay-list-container"
      >
        <div class="small-goods-scroll-wrapper">
          <div class="small-goods-list">
            <goods-cell-small
              v-for="goods in item.spus"
              :key="goods.id"
              :item="goods"
              :is-store="isStore"
              class="small-goods-cell-wrapper"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GoodsCellSmall from "./GoodsCellSmall.vue";

export default {
  name: "HomeGoodsNew",
  components: {
    GoodsCellSmall
  },
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    isStore: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      ratio: 210 / 364
    };
  },
  computed: {
    minHeight() {
      if (this.item && this.item.navigationType === 2) {
        return `calc((100vw - 24px) * ${this.ratio} + 16px)`;
      }
      return "0";
    }
  },
  methods: {
    onMoreClick() {
      this.$emit("clickMore", this.item);
    },
    onImageClick() {
      this.$emit("clickImage", this.item);
    },
    onGoodsClick(goods) {
      this.$router.push({
        path: "/product/detail",
        query: { id: goods.id }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.home-goods-new {
  width: 100%;
  margin-bottom: 12px;
  // background-color: #fff;
}
.title-with-list {
  padding: 12px;
  box-sizing: border-box;
}
.title-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.header-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
}
.see-more-btn {
  display: flex;
  align-items: center;
  color: #999;
}
.see-more-text {
  font-size: 12px;
}
.arrow-icon {
  font-size: 12px;
  margin-left: 2px;
}
.subject-goods-scroll-wrapper {
  overflow-x: auto;
  white-space: nowrap;
  width: 100%;
  -webkit-overflow-scrolling: touch;
  &::-webkit-scrollbar {
    display: none;
  }
}
.subject-goods-list {
  display: flex;
  flex-direction: row;
}
.subject-goods-cell {
  width: 100px;
  margin-right: 12px;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  text-align: left;
}
.cell-img-box {
  width: 100px;
  height: 100px;
  border-radius: 4px;
  overflow: hidden;
  background-color: #f7f8fa;
  .cell-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.cell-info {
  margin-top: 6px;
}
.cell-name {
  font-size: 12px;
  color: #333;
  line-height: 18px;
  height: 36px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal;
}
.cell-price-group {
  margin-top: 4px;
  display: flex;
  align-items: baseline;
  line-height: 1.2;
}
.cell-price-row {
  display: flex;
  align-items: baseline;
}
.price-integer {
  font-size: 12px;
  color: #333;
  font-weight: bold;
  margin-right: 4px;
}
.single-price {
  font-size: 10px;
  color: #999;
  text-decoration: line-through;
  white-space: nowrap;
}

// Image with list style
.image-with-list {
  width: 100%;
  position: relative;
  padding: 0 12px;
  box-sizing: border-box;
}
.main-image {
  width: 100%;
  border-radius: 6px;
  display: block;
}
.overlay-list-container {
  position: absolute;
  bottom: 0;
  left: 12px;
  right: 12px;
  width: calc(100% - 24px);
  padding: 8px 8px 10px;
  box-sizing: border-box;
  z-index: 2;
}
.small-goods-scroll-wrapper {
  overflow-x: auto;
  white-space: nowrap;
  width: 100%;
  -webkit-overflow-scrolling: touch;
  &::-webkit-scrollbar {
    display: none;
  }
}
.small-goods-list {
  display: flex;
  flex-direction: row;
  padding-bottom: 4px;
}
.small-goods-cell-wrapper {
  flex-shrink: 0;
}
</style>
